var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-assist',{attrs:{"value":_vm.querytext,"condition-fields":_vm.theFields},on:{"input":function($event){return _vm.updateData($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }